<template>
  <div class="panel-container">
    <!-- 头部容器 -->
    <div class="header-container">
      <!-- 标题 -->
      <div class="title-container">
        <span class="title-text">{{$str.getKey('收益管理/所选日期范围内')}}</span>
      </div>
      <!-- 操作按钮 -->
      <div class="btns-container">
      </div>
    </div>
    <div class="divider-line"></div>
    <!-- 主体容器 -->
    <div class="main-container">
      <template v-for="item in panelData.infoList" :key="item">
        <div class="info-item-container">
          <div class="right-info-wrapper">
            <div class="title-row">
              <span class="title-text">{{item.title}}</span>
              <el-tooltip :content="item.tip" placement="top" :hide-after="0" v-if="item.tip">
                <img :src="alertCircleIcon" alt="" class="tip-icon tip-icon-svg" />
              </el-tooltip>
            </div>
            <div>
              <span class="value-text">{{item.value}}</span>
              <span class="unit-text">{{item.unit}}</span>
            </div>
          </div>
        </div>
      </template>

      <div class="info-item-container bottom-tip-item">
        <div class="right-info-wrapper">
          <div class="title-row">
            <span class="title-text">{{$str.getKey('收益管理/明细内容请查看收益')}}</span>
            <el-tooltip :content="$str.getKey('收益管理/明细内容请查看收益')" placement="top" :hide-after="0">
              <img :src="alertCircleIcon" alt="" class="tip-icon tip-icon-svg" />
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, reactive, computed, watch } from "vue"
import dayjs from 'dayjs';
import useAppStore from '@/store/modules/app'
import { queryAbnormalInfo } from "../api/index.js";
import alertCircleIcon from '@/assets/icons/svg/alert-circle.svg'
const $str = window.$str;
/** 获取stationId，并监听其变化-更新数据 */
const appStore = useAppStore();
const stationId = computed(() => appStore.stationId);
const isOldStation = computed(() => appStore.isOldStation);

// 监听 stationId 变化，如果有 refreshInfoList 函数则调用
// 注意：需要确保 refreshInfoList 函数已定义
// watch(() => appStore.stationId, () => {
//   if (typeof refreshInfoList === 'function') {
//     refreshInfoList();
//   }
// }, { immediate: true });


/** 设置组件配置项 */
defineOptions({
  name: "chartPanel"
});


/** 接收父组件信息 */
const props = defineProps({
  panelData: {
    type: Object,
    default: {
      timeRange: [dayjs().subtract(1, 'month').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
    }
  },
});


const panelData = reactive({
  infoList: [
    {
      key: 'errorNum',
      title: $str.getKey('收益管理/电表数据异常'),
      value: '0',
      unit: $str.getKey('收益管理/天'),
      icon: new URL('./assets/abnormal.svg', import.meta.url).href,
      tip: $str.getKey('收益管理/当日放电电量超过两次满充满放电能'),
    },
    {
      key: 'missNum',
      title: $str.getKey('收益管理/电表数据丢失'),
      value: '0',
      unit: $str.getKey('收益管理/天'),
      icon: new URL('./assets/lost.svg', import.meta.url).href,
      tip: $str.getKey('收益管理/缺失数据'),
    },
  ],
  tipIcon: new URL('./assets/tip.svg', import.meta.url).href,
})

watch(() => props.panelData.timeRange, nv => {
  initPanel();
})


// initPanel();

/** ====== [业务：功能方法] =================================================================== */
/** 初始化面板 */
function initPanel() {
  const params = {
    stationId: stationId.value,
    startTime: dayjs(props.panelData.timeRange[0]).format('YYYY-MM-DD 00:00:00'),
    endTime: dayjs(props.panelData.timeRange[1]).format('YYYY-MM-DD 23:59:59'),
  }
  queryAbnormalInfo(params).then(res => {
    panelData.infoList.forEach(it => {
      if (it.key === 'errorNum') {
        if (Array.isArray(res?.data?.errorNum)) {
          it.value = res.data.errorNum.length;
        } else {
          it.value = 0;
        }
      }
      if (it.key === 'missNum') {
        it.value = res?.data['missNum'] ?? 0;
      }
    })
  })
}



/** ====== [辅助：功能方法] =================================================================== */

function refreshInfoList() {
  // 更新面板数据
  initPanel();

}


</script>
<style lang="scss" scoped>
.panel-container {
  --page-top: 12px;
  --header-hight: 50px;
  & {
    width: 100%;
    // height: calc(100% - var(--page-top));
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.63) 0%, rgba(255, 255, 255, 0.42) 100%);
    border-radius: 20px;
    border: 0.5px solid rgba(255, 255, 255, 1);
    backdrop-filter: blur(10px);
    margin-top: var(--page-top);
    padding: 10px 0px;
    overflow: scroll;

    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .header-container {
    width: 100%;
    height: var(--header-hight);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 10px;

    .title-container {
      height: 100%;
      flex: 1;
      padding-left: 1px;
      display: flex;
      align-items: center;
      gap: 6px;
      .title-text {
        color: #2E2E2E;
        font-family: "HarmonyOS Sans SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }

    .btns-container {
      max-width: 50%;
      height: 100%;
      padding-right: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      // gap: 10px;
    }
  }

  .divider-line {
    width: 100%;
    height: 1px;
    background: rgba(192, 207, 218, 0.5);
  }

  .main-container {
    & {
      width: 100%;
      height: calc(100% - var(--header-hight));
      flex: 1;
      overflow: scroll;
      padding: 8px 4px 4px 12px;

      /* 一排 2 个指标，2 列网格布局 */
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      column-gap: 12px;
      row-gap: 12px;
    }

    .info-item-container {
      width: 100%;
      display: flex;
      gap: 12px;

      &.bottom-tip-item {
        grid-column: 1 / -1; // 占据整行，跨2列
        
        .right-info-wrapper {
          justify-content: flex-start;
        }
      }

      .right-info-wrapper {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        gap: 4px;

        .title-row {
          display: flex;
          align-items: center;
          white-space: nowrap;
          gap: 4px;
        }

        .title-text {
          color: rgba(46, 46, 46, 0.60);
          font-family: "HarmonyOS Sans SC";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
        .tip-icon {
          cursor: pointer;
          font-size: 14px;
          color: rgba(46, 46, 46, 0.6);
          flex-shrink: 0;
        }
        .tip-icon-svg {
          width: 14px;
          height: 14px;
          display: inline-block;
          vertical-align: middle;
        }
        .value-text {
          color: #2E2E2E;
          font-family: "HarmonyOS Sans SC";
          font-size: 20px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }
        .unit-text {
          color: #2E2E2E;
          font-family: "HarmonyOS Sans SC";
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
    }

  }

}


</style>
